import { Box, LoadingOverlay, Tabs } from "@mantine/core";
import { BaseContainer, ConfigTabs, ConfigTabItem } from "../common";
import { Settings2, ListTodo, ShieldCheck } from "lucide-react";
import { UseFormReturnType } from "@mantine/form";
import type { TabGroupInput } from "@bi-studio/shared/lib";
import { TabGroupGeneralConfig } from "./TabGroupGeneralConfig";
import { TabGroupTabsConfig } from "./TabGroupTabsConfig";
import { RoleSelector } from "@/components/common/RoleSelector";

export interface TabGroupCreateViewProps {
    isSaving: boolean;
    loadingData: boolean;
    activeTab: string | null;
    setActiveTab: (tab: string | null) => void;
    form: UseFormReturnType<TabGroupInput>;
    reports: { value: string; label: string }[];
    charts: { value: string; label: string }[];
    dashboards: { value: string; label: string }[];
    forms: { value: string; label: string }[];
}

export function TabGroupCreateView({
    isSaving,
    loadingData,
    activeTab,
    setActiveTab,
    form,
    reports,
    charts,
    dashboards,
    forms,
}: TabGroupCreateViewProps) {
    const tabs: ConfigTabItem[] = [
        { value: "general", label: "General", icon: <Settings2 size={14} /> },
        { value: "tabs", label: "Tabs", icon: <ListTodo size={14} /> },
        { value: "permissions", label: "Permissions", icon: <ShieldCheck size={14} /> },
    ];

    return (
        <BaseContainer>
            <LoadingOverlay visible={isSaving || loadingData} overlayProps={{ blur: 2 }} />

            <Box p={{ base: 'xs', sm: 'md' }}>
                <ConfigTabs
                    value={activeTab}
                    onChange={setActiveTab}
                    tabs={tabs}
                >
                    <Tabs.Panel value="general">
                        <TabGroupGeneralConfig
                            form={form}
                            isSaving={isSaving}
                        />
                    </Tabs.Panel>

                    <Tabs.Panel value="tabs">
                        <TabGroupTabsConfig
                            form={form}
                            isSaving={isSaving}
                            reports={reports}
                            charts={charts}
                            dashboards={dashboards}
                            forms={forms}
                        />
                    </Tabs.Panel>

                    <Tabs.Panel value="permissions">
                        <RoleSelector
                            value={form.values.allowedRoles || []}
                            onChange={(roles) => form.setFieldValue("allowedRoles", roles)}
                            disabled={isSaving}
                        />
                    </Tabs.Panel>
                </ConfigTabs>
            </Box>
        </BaseContainer>
    );
}
